import { find, isEmpty } from 'lodash';

export const spaceName = 'odModification';

export interface ModificationSettings {
  editingId: number;
  selectedTab: 'translation' | 'pair';
  selectedTranslatedLang: string;
  originalData: {
    originalTranslation: any;
    originalPairList: any;
    originalPairInfo: any;
  };
  currentData: {
    currentTranslation: any;
    currentPairList: any;
    currentPairInfo: any;
  };
  relationData: any;
  allModifierItems: any[];
}

export default {
  selectedTab: 'translation',
  selectedTranslatedLang: 'en_AU',
  relationData: {},
} as ModificationSettings;

export const getTableColumns = (props: any) => {
  const {
    helper: { tx },
    actionButton,
    meta: { viewingLang },
  } = props;

  return [
    {
      title: tx('Management_Modifier.modifier_name'),
      dataIndex: 'name',
      key: 'tableNumodifierNamember',
      width: '600px',
      sorter: (a: any, b: any) => a.price - b.price,
      render: (name: string, record: any) => {
        const findLanguageTranslation = find(record.translations ?? [], { locale: viewingLang });

        if (findLanguageTranslation) {
          return isEmpty(findLanguageTranslation.name) ? name : findLanguageTranslation.name;
        }

        return name;
      },
    },
    {
      title: tx('Global.price'),
      dataIndex: 'price',
      key: 'price',
      width: '400px',
      render: (item: any) => (item ? `$ ${item}` : ''),
      sorter: (a: any, b: any) => a.price - b.price,
    },
    { ...actionButton },
  ];
};
